import React from "react";
import { Skeleton } from "@mui/material";
import { useTranslation } from 'react-i18next';

import './GallerySkeleton.module.css';
import styles from './HomeScreenSkeleton.module.css'

const HomeSkeleton: React.FC = () => {
    const { i18n } = useTranslation();

    return (
        <div className={`${styles['home-container']} ${styles.skelaton} ${i18n.language} homepage-skelaton`} style={{ direction: i18n.dir() }}>
            <div className={styles['home-title']}>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
            </div>

            <Skeleton variant="rounded" width={"100%"} height={'25vh'} />

            <div className={`home-subtitle ${styles.skelaton} ${i18n.language}`}>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
            </div>
            <div className={`home-description ${i18n.language} ${styles.skelaton}`}>
                <Skeleton variant="text" />
                <Skeleton variant="text" />
                <Skeleton variant="text" />
            </div>

        </div>
    );
}

export default HomeSkeleton;
